import React, { Fragment } from "react";

import Button from "@ds-developer/button";
import Modal from "@ds-developer/modal";

import { LearnerDetailsModalProps } from "./types";

import LearnerDetailsFormFields from "../../Forms/LearnerDetailsForm";
import Skeleton from "../../../../Skeleton";

const LearnerDetailsModal: React.FC<LearnerDetailsModalProps> = ({
  loading = false,
  saving = false,
  learner,
  errors,
  onCancelClicked = () => {},
  onSaveClicked = () => {},
  onFirstNameChange = () => {},
  onLastNameChange = () => {},
  onContactMobileChange = () => {},
  onContactEmailChange = () => {},
  onAddressLine1Change = () => {},
  onAddressLine2Change = () => {},
  onAddressTownChange = () => {},
  onAddressPostcodeChange = () => {},
  onDateOfBirthChange = () => {},
  onTitleChange = () => {},
  open = true,
  values,
  disabled = false,
}) => {
  const formId = "learner-details-form";

  const actions = (
    <Fragment>
      <Button onClick={onCancelClicked} variant="outlined">
        Cancel
      </Button>
      <Button
        color="primary"
        variant="contained"
        type="submit"
        form={formId}
        disabled={disabled || saving}
      >
        Save changes
      </Button>
    </Fragment>
  );

  return (
    <Modal actions={actions} open={open} title="Edit learner details">
      {loading || !learner ? (
        <Skeleton />
      ) : (
        <form id={formId} onSubmit={onSaveClicked}>
          <LearnerDetailsFormFields
            values={values}
            errors={errors}
            onFirstNameChange={onFirstNameChange}
            onLastNameChange={onLastNameChange}
            onContactMobileChange={onContactMobileChange}
            onContactEmailChange={onContactEmailChange}
            onAddressLine1Change={onAddressLine1Change}
            onAddressLine2Change={onAddressLine2Change}
            onAddressTownChange={onAddressTownChange}
            onAddressPostcodeChange={onAddressPostcodeChange}
            onDateOfBirthChange={onDateOfBirthChange}
            onTitleChange={onTitleChange}
          />
        </form>
      )}
    </Modal>
  );
};

export default LearnerDetailsModal;
